import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "./landingPage.css";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import CourseIcon from "./CourseIcon";
import CourseStats from "./CourseStats";
import { extractColorOptimized } from "../colorExtractionUtils";

const ButtonH2 = styled.button`
  background: red;
  position: relative;
  font-family: "Quicksand", sans-serif;
  /* padding-left: 15px; */
  /* padding-right: 15px; */
  /* margin: 30px; */
  text-transform: uppercase;
  /* font-size: 15px; */
  font-size: 1.4vh;
  font-weight: bold;
  overflow: hidden;
  border: 0;
  border-radius: 20% 20% 20% 20% / 50% 50% 50% 50%;
  background: none;
  color: #dd6260;
  height: 6vh;
  text-decoration: underline;

  transition: all 0.25s ease;
  cursor: pointer;
  /* margin-right: 20px; */
`;

const StartButton = styled.button`
  background: #8747d4;
  position: relative;
  font-family: "Quicksand", sans-serif;
  padding-left: 15px;
  padding-right: 15px;
  /* margin-bottom: 10px; */

  /* font-size: 15px; */
  font-size: 3vh;
  font-weight: bold;
  overflow: hidden;
  border: 0;
  border-radius: 15%;

  color: white;
  height: 6vh;

  transition: all 0.25s ease;
  cursor: pointer;
  /* margin-right: 20px; */
  margin-bottom: 40px;

  &:active {
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
    background: #f2b1ae;
  }
`;

function CourseCard(props) {
  const [dominantColor, setDominantColor] = useState("");
  const [textColor, setTextColor] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showGoals, setShowGoals] = useState(false);

  const toggleGoals = () => {
    setShowGoals(!showGoals);
  };

  const fetchAndExtractColorWithCache = async (imageUrl) => {
    try {
      const result = await extractColorOptimized(imageUrl);
      if (result) {
        setDominantColor(result.dominantColor);
        setTextColor(result.textColor);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error extracting color:", error);
      // Set default colors on error
      setDominantColor("#dd6260");
      setTextColor("#fff");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const imageUrl =
      "https://hhcourses-assets.s3.us-east-2.amazonaws.com/" +
      props.course.courseTitle.replace(/\s/g, "") +
      "/courseImage/" +
      props.course.courseTitle.replace(/\s/g, "") +
      ".png";

    fetchAndExtractColorWithCache(imageUrl);
  }, []);

  return (
    <div
      className="courseFullDetails"
      style={{ backgroundColor: dominantColor }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          color: "white",
          background: "#8747D4",
          fontWeight: "bold",
          fontSize: "4vh",
          marginBottom: "2vh",
          padding: "10px",
        }}
      >
        {props.course.courseCardTitle}
      </div>
      <div className="courseHeader">
        <CourseIcon
          img={
            "https://hhcourses-assets.s3.us-east-2.amazonaws.com/" +
            props.course.courseTitle.replace(/\s/g, "") +
            "/courseImage/" +
            props.course.courseTitle.replace(/\s/g, "") +
            ".png"
          }
          title={props.course.courseTitle}
          description={props.course.courseDescription}
        ></CourseIcon>
        <div className="courseDescriptionANDGoals">
          <CourseStats
            courseDetails={props.course}
            color={textColor}
          ></CourseStats>
        </div>
      </div>
      <h1 className="courseDescription" style={{ color: textColor }}>
        {props.course.courseDescription}
        <br></br>
        <ButtonH2 onClick={toggleGoals} style={{ color: textColor }}>
          {showGoals ? "Hide Course Details" : "Show Course Details"}
        </ButtonH2>
        ​
      </h1>
      <div style={{ textAlign: "center" }}>
        <Link to={`/${props.course.courseTitle.replace(/\s/g, "")}/start`}>
          <StartButton>Start</StartButton>
        </Link>
      </div>

      {showGoals && (
        <div className="courseGoals">
          <div className="courseGoalsDescription" style={{ color: textColor }}>
            {/* <div
              className="courseGoalsHeader"
              style={{ color: textColor, fontSize: "" }}
            >
              You will learn
            </div> */}
            {Object.entries(props.course).length === 0 ? ( //UseEffects need to fetch object details and hence object will be empty until useEffect gets data, until then this is empty
              <div>Loading</div>
            ) : (
              props.course.courseGoals.map((goal, index) => {
                return (
                  <p className="courseGoalItem">
                    <i
                      class="fa-solid fa-check"
                      style={{ color: "rgb(80, 200, 120)" }}
                    ></i>{" "}
                    {goal}
                  </p>
                );
              })
            )}
          </div>
          <div className="courseReference">
            {props.course.courseTitle && (
              <img
                className="courseReferenceImage"
                src={
                  "https://hhcourses-assets.s3.us-east-2.amazonaws.com/" +
                  props.course.courseTitle.replace(/\s/g, "") +
                  "/courseReferenceImage/" +
                  props.course.courseTitle.replace(/\s/g, "") +
                  ".png"
                }
                alt=""
              ></img>
            )}

            <div
              className="courseReferenceDescription"
              style={{ color: textColor }}
            >
              <i
                class="fa-solid fa-medal"
                style={{ color: "rgb(80, 200, 120)" }}
              ></i>{" "}
              {props.course.courseReferenceDescription}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CourseCard;
